const countNumberOfDecimals = (value: string | undefined) => {
  const valueAsNumber = Number(value);
  if (Math.floor(valueAsNumber) === valueAsNumber) {
    return 0;
  }
  return value?.split('.')[1].length ?? 0;
};

export const maxDecimals = ({ value, message, decimals }: { value: string; message: string; decimals: number }) => {
  const numberOfDecimals = countNumberOfDecimals(value);

  if (numberOfDecimals <= decimals) {
    return undefined;
  }

  return message;
};
